module.exports = __webpack_public_path__ + "assets/img/en.522cd947.png";